// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_HN5Z7","formSelect":"index_formSelect_47dnP","active":"index_active_7txtx"};